import { useContext, useEffect, useState } from 'react';
import { getYmmDetails } from '../util/get-ymm-details';
import { useParams } from 'react-router-dom';
import ServerContext from '../../../contexts/serverContext';
import { VehicleYmm } from '../../../models/vehicle-ymm';

export const useDyfVehicleYmm = (flow: 'vin' | 'ymm') => {
    const {
        year: queryYear = '',
        model: queryModel = '',
        vin: queryVin = '',
    } = useParams<{
        year?: string;
        model?: string;
        vin?: string;
    }>();
    const [{ loading, data }, setState] = useState<{
        loading: boolean;
        data: VehicleYmm | null;
    }>({ loading: true, data: null });

    const {
        brand,
        currentRegionCode,
        currentLanguageRegionCode,
        current3LetterCountryCode,
    } = useContext(ServerContext);
    useEffect(() => {
        getYmmDetails({
            flow,
            queryVin,
            queryModel,
            queryYear,
            currentLanguageRegionCode,
            current3LetterCountryCode,
            currentRegionCode,
            brand,
        }).then(res => {
            setState({ loading: false, data: res ?? null });
        });
    }, [queryVin, queryModel, queryYear]);

    return { loading, data };
};
